import { utdEpicClient } from '@wk/utd-integrated';
import { getWindow } from './utility/DOM';
import IFrameClient from './utility/IFrameClient';

// to ensure backward compatibility in ACA:
window.epicClient = utdEpicClient();
if (typeof epicClient !== 'undefined') {
    epicClient.initialize();
}

window.udaExplorer = new IFrameClient({
    name: 'UDAExplorer',
    initiateHandshake: 'UDAExplorer.InitiateHandshake',
    debug: false,
    onActivation: () => {
        getWindow().onbeforeunload = () => {
            udaExplorer.sendMessage({ action: 'UDAExplorer.Deactivate' });
        };
    }
});
if (typeof udaExplorer !== 'undefined') {
    udaExplorer.initialize();
}